module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-line"
  }, [_vm._t("default"), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "gwi-ipt ipt-code",
    attrs: {
      "type": "text",
      "name": "verifycode",
      "placeholder": "验证码",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-code",
    attrs: {
      "type": "button",
      "id": "btn-verifycode",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.sendVerifyCode
    }
  }, [_vm._v(_vm._s(_vm.btnText))])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27da66be","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VerifyCode.vue
// module id = 803
// module chunks = 0